import general from './general.json';

const Spanish = {
	general
};

export default Spanish;
